import {
  SET_COMPLIANCE_SELECTED_TASK,
  SET_COMPLIANCE_TASK_STATUS,
  SET_COMPLIANCE_VERSION_HISTORY,
} from "constants/task/esgCompliance/esgComplianceTaskConst";
import apiBolerplate from "utils/_helpers/apiBolerplate";
import { reduxGet } from "utils/_helpers/reduxGet";

// ----------------- Payloads -----------------
export function setEsgComplianceSelectedTask(payload) {
  return {
    type: SET_COMPLIANCE_SELECTED_TASK,
    payload: payload,
  };
}
export function setEsgComplianceTaskStatus(payload) {
  reduxGet.dispatch({
    type: SET_COMPLIANCE_TASK_STATUS,
    payload: payload,
  });
}
export function setEsgComplianceVersion(payload) {
  return {
    type: SET_COMPLIANCE_VERSION_HISTORY,
    payload: payload,
  };
}
// ----------------- Actions -----------------

export async function getEsgComplianceTaskList(organization_id) {
  const data = await apiBolerplate({
    url: "/tasks/get_assigned_esg_compliance_assessments",
    bodyData: { organization_id },
    hideLoader: true,
    hideMsg: true,
  });

  return data; // Return the data for further use
}

export async function getEsgComplianceTaskAssignedMetrics(taskData) {
  
  const data = await apiBolerplate({
    url: "/esg_compliance_new/assign/get_assigned_questions",
    bodyData: { ...taskData },
    hideLoader: true,
    callback: (data) => {
      setEsgComplianceTaskStatus(data?.result);
    },
    hideMsg: true,
  });
  return data; // Return the data for further use
}

export async function submitEsgComplianceTaskMetric({ file, ...taskData }) {
  const handleFile = file?.url ? { file, ...taskData } : taskData;
  let url = window.origin;
  let domain_name = window.location.hostname;
  const data = await apiBolerplate({
    url: "/esg_compliance_new/task/submit_answer",
    files: { file: file?.url ? null : file },
    bodyData: { ...handleFile,url,domain_name },
    hideLoader: true,
    customMessage:"Submission completed successfully & sent for approval",
    messageType: "success",
  });

  return data; // Return the data for further use
}

export async function getEsgComplianceTaskMetricsStatus({assessment_id, action_type}) {
  const data = await apiBolerplate({
    url: "/esg_compliance_new/task/get_summary",
    bodyData: {assessment_id,action_type},
    hideLoader: true,
    hideMsg: true,
  });

  return data; // Return the data for further use
}

export async function approveRecordedDisclosureTaskMetric(
  approve_recorded_data
) {
  const data = await apiBolerplate({
    url:
      approve_recorded_data?.from === "TASK"
        ? "/esg_compliance_task/approve_recorded_disclosure"
        : "auditor/audit_disclosure",
    bodyData: { ...approve_recorded_data },
    hideLoader: true,
    messageType: "success",
  });

  return data; // Return the data for further use
}

export function getVersionHistoryDataValidation({
  esg_compliance_id,
  metric_id,
  organization_id,
}) {
  return async (dispatch) => {
    apiBolerplate({
      url: "esg_compliance_task/get_version_history",
      hideLoader:false,
      hideMsg: true,
      bodyData: { esg_compliance_id, metric_id, organization_id },
      callback: ({result}) => {
        dispatch(setEsgComplianceVersion(result));
      },
    });
  };
}
